import { defineMessages } from 'react-intl';

export const selectAssetReusedMessages = defineMessages({
  searchPlaceholder: {
    id: 'SelectAssetPage.searchPlaceholder',
    defaultMessage: 'Search',
    description: 'Placeholder for search input',
  },
});
